import { useEffect } from 'react';

import { FlagType } from '~/flags/flags';
import { useFlag } from '~/flags/useFlag';
import { useEventCallback } from '~/hooks/useEventCallback';
import { createBufferTestCases } from '~/redux/api/methods/sylvanus/testCaseUtils';
import { Uuid } from '~/types/Uuid';

import { PromptModelTestCase } from '../types/deprecated';
import { usePrefetchDocuments } from './usePrefetchDocuments';

interface Props {
  testCases: PromptModelTestCase[];
  modelId: Uuid;
  version: number;
  activeTestCaseNumber: number;
  readOnly?: boolean;
  onAddTestCase?: (testCase: PromptModelTestCase) => void;
}

export const useMaintainTestCaseBuffer = ({
  testCases,
  modelId,
  version,
  activeTestCaseNumber,
  readOnly,
  onAddTestCase,
}: Props) => {
  const isCustomAiAsyncTestCreationExecutionEnabled = useFlag(
    FlagType.CustomAiAsyncTestCreationExecution,
  );
  const highlightMethod = useFlag(FlagType.CustomAiHighlightMethod);

  const { prefetchDocuments } = usePrefetchDocuments();

  const handleAddTestCase = useEventCallback(
    (testCase: PromptModelTestCase) => {
      onAddTestCase?.(testCase);
      if (testCase?.entity?.id) {
        prefetchDocuments([Number(testCase.entity.id)]);
      }
    },
  );

  useEffect(() => {
    if (
      !isCustomAiAsyncTestCreationExecutionEnabled ||
      testCases.length === 0 ||
      readOnly
    ) {
      return;
    }

    createBufferTestCases(modelId, version, {
      currentTestCasesCount: testCases.length,
      activeTestCaseNumber,
      onAddTestCase: handleAddTestCase,
      highlightMethod,
    });
  }, [
    isCustomAiAsyncTestCreationExecutionEnabled,
    testCases.length,
    modelId,
    version,
    activeTestCaseNumber,
    readOnly,
    highlightMethod,
  ]);
};
